import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "interest-female-fashion--sprite",
  "use": "interest-female-fashion--sprite-usage",
  "viewBox": "0 0 8 16",
  "content": "<symbol viewBox=\"0 0 8 16\" id=\"interest-female-fashion--sprite\">\n<path d=\"M2.39898 1.60112C2.39898 0.716194 3.11518 0 4.00011 0C4.88504 0 5.60123 0.716194 5.60123 1.60112C5.60123 2.48606 4.88504 3.20225 4.00011 3.20225C3.11518 3.1985 2.39898 2.48231 2.39898 1.60112ZM5.56374 5.09585C5.34625 4.43965 4.73505 4.00094 4.04886 4.00094H3.95511C3.26892 4.00094 2.65396 4.43965 2.44023 5.09585L0.400391 11.2004H2.8002V16H5.20002V11.2004H7.59983L5.56374 5.09585Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol